<div class="modal-envio-detalle">
  <h2 mat-dialog-title class="d-flex align-items-center gap-2">
    <mat-icon class="title-icon">receipt_long</mat-icon>
    Detalle de envío #{{ data.id }}
  </h2>

  <mat-dialog-content>

    <!-- Cargando -->
    <div class="state-container" *ngIf="cargando">
      <mat-spinner diameter="36"></mat-spinner>
      <p class="state-text">Cargando detalle...</p>
    </div>

    <!-- Error -->
    <div class="state-container state-error" *ngIf="!cargando && error">
      <mat-icon class="state-icon-error">error_outline</mat-icon>
      <p class="state-text">{{ error }}</p>
      <button class="btn btn-sm btn-outline-danger mt-2" (click)="cargarDetalle()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>

    <!-- Contenido -->
    <div *ngIf="!cargando && !error && detalle">

      <!-- Estado -->
      <div class="estado-banner" [ngClass]="detalle.STATUS === 'SUCCESS' ? 'estado-success' : 'estado-error'">
        <mat-icon>{{ detalle.STATUS === 'SUCCESS' ? 'check_circle' : 'cancel' }}</mat-icon>
        <span>{{ detalle.STATUS }} · Código {{ detalle.STATUS_CODE }}</span>
      </div>

      <!-- Datos principales -->
      <div class="detalle-grid">
        <div class="detalle-item">
          <span class="detalle-label">Pedido SEUS</span>
          <span class="detalle-value">{{ detalle.NUM_PEDIDO_SEUS || '-' }}</span>
        </div>
        <div class="detalle-item">
          <span class="detalle-label">Entrega SAP</span>
          <span class="detalle-value">{{ detalle.NUM_ENTREGA_SAP || '-' }}</span>
        </div>
        <div class="detalle-item">
          <span class="detalle-label">Categoría</span>
          <span class="detalle-value">{{ detalle.CATEGORY || '-' }}</span>
        </div>
        <div class="detalle-item">
          <span class="detalle-label">Schema</span>
          <span class="detalle-value">{{ detalle.SCHEMA_CODE || '-' }}</span>
        </div>
        <div class="detalle-item">
          <span class="detalle-label">Tipo de operación</span>
          <span class="detalle-value">{{ detalle.DETALLE || '-' }}</span>
        </div>
        <div class="detalle-item">
          <span class="detalle-label">Fecha de envío</span>
          <span class="detalle-value">{{ detalle.FECHA_ENVIO | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
        </div>
        <div class="detalle-item">
          <span class="detalle-label">Usuario</span>
          <span class="detalle-value">{{ detalle.USUARIO_CREACION || '-' }}</span>
        </div>
        <div class="detalle-item">
          <span class="detalle-label">Reintento</span>
          <span class="detalle-value">{{ detalle.REINTENTO === 'S' ? 'Sí' : 'No' }}</span>
        </div>
        <div class="detalle-item detalle-item-full">
          <span class="detalle-label">URL destino</span>
          <span class="detalle-value detalle-url">
            {{ detalle.URL }}
            <mat-icon class="copy-icon" matTooltip="Copiar URL" (click)="copiarUrl()">content_copy</mat-icon>
          </span>
        </div>
      </div>

      <!-- Respuesta del servicio -->
      <div class="respuesta-section">
        <div class="d-flex align-items-center gap-2 mb-2">
          <mat-icon class="section-icon">dns</mat-icon>
          <span class="section-title">Respuesta del servicio</span>
        </div>

        <div *ngIf="respuestaInvalida" class="respuesta-sin-datos">
          No se pudo interpretar la respuesta del servicio.
        </div>

        <div *ngIf="!respuestaInvalida && !respuesta" class="respuesta-sin-datos">
          Este registro no tiene información de respuesta.
        </div>

        <div *ngIf="respuesta">
          <div class="estado-banner" [ngClass]="respuesta.success ? 'estado-success' : 'estado-error'">
            <mat-icon>{{ respuesta.success ? 'task_alt' : 'error' }}</mat-icon>
            <span>{{ respuesta.success ? 'Envío exitoso' : 'Envío con errores' }} · {{ respuesta.status }}</span>
          </div>

          <div class="grupos-pedidos">

            <mat-expansion-panel class="grupo-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="grupo-icon grupo-added">add_circle_outline</mat-icon>
                  Agregados
                </mat-panel-title>
                <mat-panel-description>{{ respuesta.response?.added?.length || 0 }} pedido(s)</mat-panel-description>
              </mat-expansion-panel-header>
              <div class="chips-pedidos" *ngIf="respuesta.response?.added?.length; else sinRegistrosAdded">
                <span class="chip-pedido" *ngFor="let pedido of respuesta.response?.added">{{ pedido }}</span>
              </div>
              <ng-template #sinRegistrosAdded><span class="sin-registros">Sin pedidos agregados.</span></ng-template>
            </mat-expansion-panel>

            <mat-expansion-panel class="grupo-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="grupo-icon grupo-edited">edit</mat-icon>
                  Editados
                </mat-panel-title>
                <mat-panel-description>{{ respuesta.response?.edited?.length || 0 }} pedido(s)</mat-panel-description>
              </mat-expansion-panel-header>
              <div class="chips-pedidos" *ngIf="respuesta.response?.edited?.length; else sinRegistrosEdited">
                <span class="chip-pedido" *ngFor="let pedido of respuesta.response?.edited">{{ pedido }}</span>
              </div>
              <ng-template #sinRegistrosEdited><span class="sin-registros">Sin pedidos editados.</span></ng-template>
            </mat-expansion-panel>

            <mat-expansion-panel class="grupo-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="grupo-icon grupo-skipped">block</mat-icon>
                  Omitidos
                </mat-panel-title>
                <mat-panel-description>{{ respuesta.response?.skipped?.length || 0 }} pedido(s)</mat-panel-description>
              </mat-expansion-panel-header>
              <div class="chips-pedidos" *ngIf="respuesta.response?.skipped?.length; else sinRegistrosSkipped">
                <span class="chip-pedido" *ngFor="let pedido of respuesta.response?.skipped">{{ pedido }}</span>
              </div>
              <ng-template #sinRegistrosSkipped><span class="sin-registros">Sin pedidos omitidos.</span></ng-template>
            </mat-expansion-panel>

          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="cerrar()">Cerrar</button>
  </mat-dialog-actions>
</div>
